export default "__VITE_ASSET__BZnwUa8W__"